/* ZonaPhone — trade-in al comprar (tarjeta del carrito, snippets/zp-cart-tradein.liquid).
 *
 * "Tasar" / "Cambiar": abre un panel sobre el carrito (lateral en escritorio,
 * pantalla completa en móvil) con "Volver al carrito" e "Ir a pagar" siempre a mano; trae el
 * cotizador de /pages/tradein por Section Rendering API y lo arranca en modo
 * carrito (assets/zp-tradein-quote.js). Al guardar, la tasación ya está en los
 * atributos del carrito: se cierra la hoja y se re-renderiza el carrito con el
 * evento nativo del tema 'cart:refresh'.
 * "Quitar" (y una tasación huérfana, sin iPhone en el carrito) vacía los atributos.
 *
 * Handlers delegados en document: el drawer reemplaza su innerHTML al re-renderizar.
 * Los clics dentro de la hoja no se propagan: el tema cierra el drawer con
 * cualquier clic fuera de él.
 */
(function () {
  'use strict';
  if (window.__zpCartTradeinBound) return;
  window.__zpCartTradeinBound = true;

  // Por nombre de archivo, no por la clave de la plantilla: en un template JSON el id
  // real es "template--<id>__zp_tradein_quote" (cambia por tema) y la clave pelada da 404.
  // Renderizada suelta usa los valores por defecto de la sección (WhatsApp incluido).
  var SECTION_ID = 'zp-tradein-quote';

  // ---------- GA4 ----------
  // window.zpTrack (snippets/zp-repair-tracking.liquid) solo existe en reparaciones
  // y /pages/tradein, pero el carrito está en todas las páginas. Aquí, si falta, se
  // define uno equivalente que carga gtag.js solo al primer evento (sin page_view:
  // ese lo manda el canal de Google de Shopify; comparte la cookie _ga).
  // Mismo ID y misma comprobación de consentimiento que zp-repair-tracking.
  // Los eventos del carrito no son leads (no avisan a OpenAI Ads).
  var GA4_ID = 'G-YQQGNDYMM9';
  if (!window.zpTrack) {
    var gtagLoaded = false;
    window.zpTrack = function (name, params) {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) return;
      } catch (e) {}
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) window.gtag = function () { window.dataLayer.push(arguments); };
      if (!gtagLoaded) {
        gtagLoaded = true;
        var s = document.createElement('script');
        s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
        document.head.appendChild(s);
        window.gtag('js', new Date());
        window.gtag('config', GA4_ID, { send_page_view: false });
      }
      params = params || {};
      params.page_path = location.pathname;
      params.transport_type = 'beacon';
      window.gtag('event', name, params);
      window.dataLayer.push(Object.assign({ event: name }, params));
    };
  }
  var BACK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  var loaded = {};
  function loadScript(src) {
    if (!loaded[src]) {
      loaded[src] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src; s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return loaded[src];
  }
  // El cotizador puede estar ya cargado (en /pages/tradein): no volver a pedirlo.
  function loadQuote(card) {
    var core = window.ZPTradeinQuote ? Promise.resolve() : loadScript(card.getAttribute('data-core-src'));
    return core.then(function () {
      return window.ZPTradeinQuoteUI ? null : loadScript(card.getAttribute('data-ui-src'));
    });
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  function updateAttributes(attrs) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (!r.ok) throw new Error('cart_update_' + r.status); });
  }

  // ---------- hoja ----------
  var sheet = null, lastFocus = null;

  function closeSheet() {
    if (!sheet) return;
    sheet.remove();
    sheet = null;
    document.documentElement.classList.remove('zp-cts-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') closeSheet(); }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  // Panel "dentro del carrito": volver al carrito arriba, total + "Ir a pagar" abajo.
  function openSheet(card) {
    if (sheet) return;
    lastFocus = document.activeElement;
    sheet = el('div', 'zp-cts');
    var backdrop = el('div', 'zp-cts__backdrop');
    backdrop.addEventListener('click', closeSheet);
    var panel = el('div', 'zp-cts__panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', card.getAttribute('data-title'));

    var bar = el('div', 'zp-cts__bar');
    var back = el('button', 'zp-cts__back');
    back.type = 'button';
    back.innerHTML = BACK_SVG;
    back.appendChild(document.createTextNode(card.getAttribute('data-back')));
    back.addEventListener('click', closeSheet);
    bar.appendChild(back);

    var body = el('div', 'zp-cts__body');
    body.appendChild(el('p', 'zp-cts__loading', card.getAttribute('data-loading')));

    var foot = el('div', 'zp-cts__foot');
    var total = el('span', 'zp-cts__total', card.getAttribute('data-total-label'));
    total.appendChild(el('b', '', card.getAttribute('data-total')));
    var pay = el('a', 'zp-cts__pay', card.getAttribute('data-checkout'));
    pay.href = card.getAttribute('data-checkout-url');
    pay.addEventListener('click', function () {
      if (window.zpTrack) window.zpTrack('tradein_cart_checkout', {}, { lead: false });
    });
    foot.appendChild(total); foot.appendChild(pay);

    panel.appendChild(bar); panel.appendChild(body); panel.appendChild(foot);
    sheet.appendChild(backdrop); sheet.appendChild(panel);
    // Que el clic no llegue a documentElement: el tema cerraría el drawer.
    sheet.addEventListener('click', function (e) { e.stopPropagation(); });
    document.body.appendChild(sheet);
    document.documentElement.classList.add('zp-cts-open');
    document.addEventListener('keydown', onKey);
    back.focus();

    var page = card.getAttribute('data-page-url') + '?section_id=' + SECTION_ID;
    Promise.all([
      fetch(page, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('section_' + r.status); return r.text(); }),
      loadQuote(card)
    ]).then(function (res) {
      if (!sheet) return; // la cerró mientras cargaba
      body.innerHTML = res[0];
      var tq = body.querySelector('[data-zp-tq]');
      if (!tq || !window.ZPTradeinQuoteUI) throw new Error('no_quote');
      window.ZPTradeinQuoteUI.init(tq, {
        cart: true,
        onSaved: function () { closeSheet(); refreshCart(); }
      });
    }).catch(function () {
      if (!sheet) return;
      body.innerHTML = '';
      body.appendChild(el('p', 'zp-cts__error', card.getAttribute('data-error')));
    });
  }

  // ---------- quitar ----------
  function clearTradein(card, src) {
    if (card) card.classList.add('is-loading');
    var core = window.ZPTradeinQuote ? Promise.resolve() : loadScript(src);
    return core.then(function () { return updateAttributes(window.ZPTradeinQuote.clearCartAttributes()); })
      .then(refreshCart)
      .catch(function () { if (card) card.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-zp-ct-open]');
    var remove = e.target.closest('[data-zp-ct-remove]');
    if (!open && !remove) return;
    var card = e.target.closest('[data-zp-cart-tradein]');
    if (!card) return;
    e.preventDefault();
    if (open) {
      if (window.zpTrack) window.zpTrack('tradein_cart_open', { state: card.classList.contains('zp-ct--done') ? 'change' : 'new' }, { lead: false });
      openSheet(card);
    } else {
      clearTradein(card, card.getAttribute('data-core-src'));
    }
  });

  // Tasación sin iPhone en el carrito: se borra sola (al cargar y tras cada re-render).
  var clearingOrphan = false;
  function checkOrphan() {
    var o = document.querySelector('[data-zp-ct-orphan]');
    if (!o || clearingOrphan) return;
    clearingOrphan = true;
    clearTradein(null, o.getAttribute('data-core-src')).then(function () { clearingOrphan = false; });
  }
  // 'cart:rerendered' del drawer no burbujea hasta document: se vigila el DOM.
  var orphanTimer = null;
  function start() {
    checkOrphan();
    new MutationObserver(function () {
      clearTimeout(orphanTimer);
      orphanTimer = setTimeout(checkOrphan, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
